import { useInvoicesListPage } from './list/useInvoicesListPage';
import { InvoicesListView } from './list/InvoicesListView';

const InvoicesPage = () => {
    const page = useInvoicesListPage();
    return <InvoicesListView page={page} />;
};

export default InvoicesPage;
